import { render } from "./titlePanel.vue?vue&type=template&id=47ca6995&scoped=true"
import script from "./titlePanel.vue?vue&type=script&lang=js"
export * from "./titlePanel.vue?vue&type=script&lang=js"

import "./titlePanel.vue?vue&type=style&index=0&id=47ca6995&lang=scss&scoped=scoped"

import exportComponent from "E:\\giteeWorkShowma\\hardware-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ca6995"]])

export default __exports__